import { useContext } from 'react';

import { SignFormContext } from './context';

export function useInsideMobileModal(): boolean {
	const context = useContext(SignFormContext);
	return !!context?.insideMobileModal;
}
